import { Trans } from "@lingui/react";
import { Alert } from "@warp-ds/elements/react/alert";
import type { SmallboatRegistryState } from "src/server/models/SmallboatRegistryModel.ts";

type Props = {
  smallBoatState?: SmallboatRegistryState;
};

export const SmabatAlert = ({ smallBoatState }: Props) => {
  const registrationUrl = new URL("https://minside.rs.no/vessels/register");

  if (smallBoatState === "new") {
    return (
      <Alert show variant="info" className="mt-16">
        <h3 role="alert" className="t4">
          <Trans
            id="tradeOrgLayout.smabatregisteret.alert.newBoat.title"
            message="This boat is new and has therefore never been registered in the small boat register."
            comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
          />
        </h3>
        <a className="text-m" href={registrationUrl.toString()}>
          <Trans
            id="tradeOrgLayout.smabatregisteret.alert.newBoat.link"
            message="New registration form"
            comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
          />
        </a>
      </Alert>
    );
  }
  if (smallBoatState === "registered") {
    return (
      <Alert show variant="positive" className="mt-16">
        <h3 role="alert" className="t4">
          <Trans
            id="tradeOrgLayout.smabatregisteret.alert.registeredBoat.title"
            message="This boat is registered in the Småbåtregisteret."
            comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
          />
        </h3>
        <a className="text-m" href={registrationUrl.toString()}>
          <Trans
            id="tradeOrgLayout.smabatregisteret.alert.registeredBoat.link"
            message="Re-registration form"
            comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
          />
        </a>
      </Alert>
    );
  }
  if (smallBoatState === "registration-in-progress") {
    return (
      <Alert show variant="warning" className="mt-16">
        <h3 role="alert" className="t4">
          <Trans
            id="tradeOrgLayout.smabatregisteret.alert.registrationInProgress.title"
            message="The boat is being registered in the Småbåtregisteret. The Norwegian Sea Rescue Society is verifying the data."
            comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
          />
        </h3>
        <a className="text-m" href={registrationUrl.toString()}>
          <Trans
            id="tradeOrgLayout.smabatregisteret.alert.registrationInProgress.link"
            message="Re-registration form"
            comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
          />
        </a>
      </Alert>
    );
  }

  // default case, e.g. if smallBoatState is "not-registered", failed or undefined
  return (
    <Alert show variant="negative" className="mt-16">
      <h3 role="alert" className="t4">
        <Trans
          id="tradeOrgLayout.smabatregisteret.alert.failed.title"
          message="We did not find information about whether this boat is registered in the Småbåtregister."
          comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
        />
      </h3>
      <p className="text-m">
        <Trans
          id="tradeOrgLayout.smabatregisteret.alert.failed.text"
          message="It is possible that the owner has filled in the wrong registration number or has not filled in the registration number at all."
          comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
        />{" "}
        <a className="text-m" href={registrationUrl.toString()}>
          <Trans
            id="tradeOrgLayout.smabatregisteret.alert.failed.link"
            message="New registration form"
            comment="Do not edit the translation submitted. Pre-approved text, must not deviate."
          />
        </a>
      </p>
    </Alert>
  );
};
